import dateFormat from "../../../../../dateFormat";

function ObjectsTable({ onEdit, objects, isMobile, onDelete }) {
  const styles = {
    th: {
      bgColor: "#f0f0f0ff",
    },
  };

  const headers1 = ["Supplier", "Gross Value"];

  const headers2 = ["Net Value", "Vat Value"];

  return (
    <>
      <div className="overflow-y-auto">
        <table className="table mt-3">
          <thead>
            <tr className="fs-sm">
              {headers1.map((header) => {
                return (
                  <th
                    scope="col"
                    style={{ backgroundColor: `${styles.th.bgColor}` }}
                  >
                    {header}
                  </th>
                );
              })}
              {!isMobile && (
                <>
                  {headers2.map((header) => {
                    return (
                      <th
                        scope="col"
                        style={{ backgroundColor: `${styles.th.bgColor}` }}
                      >
                        {header}
                      </th>
                    );
                  })}
                </>
              )}

              <th
                scope="col"
                className="text-center"
                style={{ backgroundColor: `${styles.th.bgColor}` }}
              >
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {objects.length !== 0 ? (
              objects?.map((data, index) => {
                const { date, supplier, gross, vat, net } = data;

                return (
                  <tr key={index}>
                    <td className="fs-sm" style={{ minWidth: "170px" }}>{`${
                      supplier?.name || ""
                    } - ${supplier?.city}`}</td>
                    <td className="fs-sm" style={{ minWidth: "100px" }}>
                      ₱ {gross}
                    </td>
                    {!isMobile && (
                      <>
                        <td>₱ {net}</td>
                        <td>₱ {vat}</td>
                      </>
                    )}
                    <td className="fs-sm d-flex justify-content-center">
                      <button
                        className="btn btn-primary me-2 bg-primary"
                        onClick={() => onEdit(data)}
                      >
                        <i className="bi bi-pencil-square"></i>
                      </button>
                      <button
                        className="btn btn-danger"
                        onClick={() => onDelete(data?.id)}
                        style={{ backgroundColor: "#E63946" }}
                      >
                        <i className="bi bi-trash"></i>
                      </button>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={6}>
                  <p className="my-1 text-center">No Data Found</p>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}

export default ObjectsTable;
